import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // utiliza el almacenamiento local del navegador como almacenamiento predeterminado
import rootReducer from './reducers/rootReducer';


const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'], 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };
